export const Features = {
  altContact: process.env.REACT_APP_FEATURE_ALT_CONTACT === "true",
  idProofMandatory: process.env.REACT_APP_FEATURE_ID_PROOF_MANDATORY === "true",
  screeningRoom: process.env.REACT_APP_FEATURE_SCREENING_ROOM_INFO === "true",
  profilePhoto: process.env.REACT_APP_FEATURE_UPLOAD_PROFILE_PHOTO === "true"
};
